/** Minimum cadence for an owner-enabled native-content snapshot loop. */
export const MIN_NATIVE_CONTENTS_SNAPSHOT_INTERVAL_MS = 1000;

export function normalizeSnapshotInterval(intervalMs: number): number {
  return intervalMs > 0
    ? Math.max(MIN_NATIVE_CONTENTS_SNAPSHOT_INTERVAL_MS, intervalMs)
    : 0;
}

/**
 * Keep the currently painted URL stable while the native layer is hidden.
 * Captures may finish during suppression, but their result must not replace the
 * fallback that is already known to be painted.
 */
export function shouldFreezeSnapshotCommit(
  suppressionRequested: boolean,
  currentUrl: string | undefined,
  paintedUrl: string | undefined,
): boolean {
  return (
    suppressionRequested &&
    paintedUrl !== undefined &&
    currentUrl === paintedUrl
  );
}

/** Return the last painted URL unless it is the URL that just failed. */
export function resolveFailedSnapshotFallback(
  failedUrl: string,
  paintedUrl: string | undefined,
): string | undefined {
  return paintedUrl === failedUrl ? undefined : paintedUrl;
}
